"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
const handleError_1 = require("./handleError");
const serverRenderReactComponent_1 = require("./serverRenderReactComponent");
const ReactOnRails_client_1 = require("./ReactOnRails.client");
if (typeof window !== 'undefined') {
    // warn to include a collapsed stack trace
    console.warn('Optimization opportunity: "react-on-rails" includes ~14KB of server-rendering code. Browsers may not need it. See https://forum.shakacode.com/t/how-to-use-different-versions-of-a-file-for-client-and-server-rendering/1352 (Requires creating a free account). Click this for the stack trace.');
}
/**
 * Used by Rails to catch errors in rendering
 * @param options
 */
ReactOnRails_client_1.default.handleError = (options) => (0, handleError_1.default)(options);
/**
 * Used by server rendering by Rails
 * @param options
 */
ReactOnRails_client_1.default.serverRenderReactComponent = (options) => (0, serverRenderReactComponent_1.default)(options);
__exportStar(require("./types"), exports);
exports.default = ReactOnRails_client_1.default;
